import { computed } from "vue";
import type { RouteLocation } from "vue-router";
import { useRoute } from "vue-router";

import { config } from "@/config";

export function useBackUrl(route: RouteLocation = useRoute()) {
  return computed(() => route.meta.backUrl ?? `/${config.app.language}/`);
}
